import DefaultPageCard from '../hits/default-page';
import DefaultProductCard from '../hits/default-product';
import TradeProductCard from '../hits/trade-product';
import TradeResourceCard from '../hits/trade-resource';

export const GenerateImageTag = (item, html, classList) => {
    if (!item.image || item.image === '') {
        let siteHandle = 'default';
        
        switch (item.site) {
            case 'Tavistock':
                siteHandle = 'tavistock';
                break;
            case 'R2':
                siteHandle = 'r2';
                break;
            case 'Trade Solutions':
                siteHandle = 'trade';
                break;
            default:
                break;
        }
        return html`<img class="${ classList ? classList : '' }" src="/images/default-${ siteHandle }.jpg" alt="${ item.title }" />`;
    }

    return html`<img class="${ classList ? classList : '' }" src="" srcset="${ item.image }" alt="${ item.title }" />`
};

export const getCard = (item, html) => {
    if(item.site == 'Trade Solutions') {
        if (item.type == 'product' || item.type == 'products') {
            return TradeProductCard(item, html);
        }

        return TradeResourceCard(item, html);
    }
    if (item.type == 'product' || item.type == 'products') {
        return DefaultProductCard(item, html);
    }

    return DefaultPageCard(item, html);
}